import { render, staticRenderFns } from "./LoginChangeForm.vue?vue&type=template&id=2bfcddbf&lang=pug&"
import script from "./LoginChangeForm.vue?vue&type=script&lang=js&"
export * from "./LoginChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports